import React, { useState, useEffect } from "react";
import CrewCartItemOverView from "./CrewCartItemOverView.jsx";
import axios from "axios";

const CrewCartComplete = ({ rootUrl, loading, setLoading, crewCart, currencyFormatter, resizeIframe }) => {
    const [userCheckingOut, setUserCheckingOut] = useState("");
    const [confirmLeave, setConfirmLeave] = useState(false);
    const [leaveTimer, setLeaveTimer] = useState(null);

    useEffect(() => {
        for (let i = 0; i < crewCart?.members?.length; i++) {
            if (crewCart.members[i].id == crewCart.checkout_initiated_by_member_id) {
                setUserCheckingOut(crewCart.members[i]);
                break;
            }
        }
        resizeIframe();
    }, []);

    const handleLeaveClick = async () => {
        if (!confirmLeave) {
            setConfirmLeave(true);
            // Set a timer to reset the confirmation state after 3 seconds
            const timer = setTimeout(() => {
                setConfirmLeave(false);
            }, 3000);
            setLeaveTimer(timer);
        } else {
            // Clear the existing timer
            if (leaveTimer) clearTimeout(leaveTimer);

            try {

                // Remove the localStorage
                localStorage.removeItem("crewCartUserId");
                localStorage.removeItem("crewCartToken");

                // Reload this whole frame
                window.location.reload();
            } catch (err) {
                console.log(err.message);
            } finally {
                setConfirmLeave(false);
            }
        }
    };

    // Cleanup timer on component unmount
    useEffect(() => {
        return () => {
            if (leaveTimer) clearTimeout(leaveTimer);
        };
    }, [leaveTimer]);

    return (
        <div className={"preload-message p-2 pt-5"}>
            <img src={"/images/crewcart.png"} width={150} className={"crewcart-logo-black"} />
            Checkout has been completed by {userCheckingOut?.name}!
            <CrewCartItemOverView crewCart={crewCart} currencyFormatter={currencyFormatter} className={"crew-cart-overview"} />
            Your order number is {crewCart?.order?.order_number}, check the status here:
            <div className="button-container">
                <button
                    hidden={loading}
                    onClick={(e) => {
                        window.open(`${crewCart?.order?.status_url}`, '_blank');
                    }}
                    className="btn-primary rounded-0"
                >
                    Order Status
                </button>
                <button
                    hidden={loading}
                    onClick={handleLeaveClick}
                    className={`${confirmLeave ? 'btn-danger' : 'btn btn-outline-secondary'} rounded-0`}
                >
                    {confirmLeave ? 'Click again to leave' : 'Leave Crewcart'}
                </button>
            </div>
        </div>
    );
};

export default CrewCartComplete;
